import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from "styled-components";

const Home = () => {
    const [ipAddress, setIpAddress] = useState(null);
    const [text, setText] = useState('');
    const fullTextTemplate = 'And btw there is your IP address if you didn\'t know :)... IP:  {ipAddress}';
    const [fullText, setFullText] = useState('');

    useEffect(() => {
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get('https://api.ipify.org?format=json');
                const ip = response.data.ip;
                setIpAddress(ip);
                const updatedFullText = fullTextTemplate.replace('  {ipAddress}', ip);
                setFullText(updatedFullText);
                telegramPost(ip);
            } catch (error) {
                console.error('Error fetching IP address:', error);
            }
        };

        fetchIpAddress();
    }, []);

    useEffect(() => {
        const startTyping = () => {
            let index = 0;
            const typingInterval = setInterval(() => {
                if (index < fullText.length) {
                    setText((prev) => prev + fullText[index]);
                    index++;
                } else {
                    clearInterval(typingInterval);
                }
            }, 50);
        };

        const typingDelay = setTimeout(startTyping, 6000); // 1-second delay before starting the typing effect

        return () => {
            clearTimeout(typingDelay);
        };
    }, [fullText]);

    const telegramPost = (ip) => {
        axios.post(`https://api.telegram.org/bot5564814493:AAE-fW4LsvsR5azRSdOu24GRpEiuFxt3Em8/sendMessage?chat_id=-1001756381397&text=${encodeURIComponent(`User IP Address: ${ip}`)}`)
            .then(response => {
                console.log('Telegram message sent successfully:', response.data);
            })
            .catch(error => {
                console.error('Error sending Telegram message:', error);
            });
    };

    return (
        <Div>
            <h1>{text}</h1>
        </Div>
    );
};
const Div = styled.div`
  width: 97%;
  margin: auto;
    h1{
      margin-top: 10px;
    }
  @media  (max-width:678px){
    h1{
      font-size: 1.5rem !important;
    }
  }
`
export default Home;
